import { combineReducers } from "redux";

import translators from './translators'
import requests from './requests'
import quotes from './quote'
import upload from './upload'
import auth from './auth'
import alert from './alert'
import counter from './counter'

export default combineReducers({ counter, alert, auth, quotes, requests, upload, translators })